import { render, staticRenderFns } from "./SurveyViewConfigsModal.vue?vue&type=template&id=1941b226"
import script from "./SurveyViewConfigsModal.vue?vue&type=script&lang=js"
export * from "./SurveyViewConfigsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports